import { TrackingEvent } from '../AnalyticsContext/TrackingEvent';
import { useAnalytics } from '../AnalyticsContext/useAnalytics';
import { useExposedToWindow } from '../hooks/useExposedToWindow';
import { WebVitalsMetric } from './types';

export const PerformanceReporter = () => {
  const { trackEvent } = useAnalytics();

  /** The reportWebVitals() function in _app.ts will get invoked by Nextjs on the client, and will
   * invoke this function when it is defined */
  useExposedToWindow('handleWebVitals', performanceMetrics => {
    trackEvent(TrackingEvent.PERFORMANCE_REPORTED, {
      eventData: { webVitals: performanceMetrics },
    });
  });

  return null;
};

declare global {
  interface Window {
    handleWebVitals?: (items: WebVitalsMetric[]) => void;
  }
}
